import axios from 'axios';

axios.defaults.withCredentials = true;

export async function getEval(idcurso) {
  try {
    const response = await axios.post(`${import.meta.env.VITE_APP_API_URL}get-eval`, { idcurso },
      {
        responseType: 'arraybuffer',
      }
    );
    return response

  } catch (error) {
    console.error('Error al obtener la evaluacion del alumno', error);
    return { data: { message: 'Error al obtener la evaluacion del alumno' } }
  }
}